let active = null;
let sequence = 0;
let hostCount = 0;
const alerts = [];
const listeners = new Set();
const emit = () => listeners.forEach(listener => listener());

export const getGrainDialogSnapshot = () => active;
export function subscribeGrainDialog(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function registerGrainDialogHost() {
  hostCount += 1;
  return () => {
    hostCount -= 1;
    if (hostCount === 0) cancelGrainDialogs();
  };
}

function open(description, options, kind) {
  if (typeof document === "undefined" || hostCount === 0) return Promise.resolve(false);
  // A second click must never resume the same mutation twice.
  if (active && kind === "confirm") return Promise.resolve(false);
  return new Promise(resolve => {
    const request = { id: ++sequence, kind, description: String(description || ""), options, resolve, previousFocus: document.activeElement };
    if (active) alerts.push(request);
    else { active = request; emit(); }
  });
}

export const confirmInGrain = (description, options = {}) => open(description, options, "confirm");
export const alertInGrain = (description, options = {}) => open(description, options, "alert");

export function settleGrainDialog(id, accepted) {
  if (!active || active.id !== id) return;
  const previous = active;
  active = alerts.shift() || null;
  emit();
  previous.resolve(accepted === true);
  if (!active) queueMicrotask(() => {
    if (!active && previous.previousFocus?.isConnected) previous.previousFocus.focus?.({ preventScroll: true });
  });
}

export function cancelGrainDialogs() {
  const pending = [active, ...alerts].filter(Boolean);
  active = null;
  alerts.length = 0;
  emit();
  pending.forEach(request => request.resolve(false));
}
